import React, { useState, useEffect } from "react";
import styles from "./SessionTimeoutModal.module.css";

const secondsUntil = (deadline) => Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
const mmss = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

// Counts down to a shared deadline (same for every open tab) rather than a fixed 60 s,
// so all tabs show the same remaining time even if one opened the popup later.
// variant "idle": inactivity warning (can be extended); "end": maximum login duration
// reached, cannot be extended — only "Verstanden" (onStay) to close the popup.
const SessionTimeoutModal = ({ variant = "idle", deadline, warningDurationSecs = 60, onStay, onLogout }) => {
  const [countdown, setCountdown] = useState(() => secondsUntil(deadline));

  useEffect(() => {
    setCountdown(secondsUntil(deadline));
    const interval = setInterval(() => setCountdown(secondsUntil(deadline)), 500);
    return () => clearInterval(interval);
  }, [deadline]);

  if (variant === "end") {
    return (
      <div className={styles.overlay}>
        <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="timeout-title">
          <div className={styles.iconWrapper}>&#9201;</div>
          <h2 id="timeout-title" className={styles.title}>Sitzung endet bald</h2>
          <p className={styles.inactiveNote}>Maximale Sitzungsdauer erreicht.</p>
          <p className={styles.message}>
            Ihre Sitzung wird in <strong>{mmss(countdown)}</strong> Minuten automatisch beendet
            und kann nicht verlängert werden. Bitte speichern Sie Ihre aktuelle Arbeit.
          </p>
          <div className={styles.progressTrack}>
            <div
              className={styles.progressFill}
              style={{ width: `${Math.min(100, (countdown / warningDurationSecs) * 100)}%` }}
            />
          </div>
          <div className={styles.actions}>
            <button className={styles.btnPrimary} onClick={onStay}>
              Verstanden
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="timeout-title">
        <div className={styles.iconWrapper}>&#9201;</div>
        <h2 id="timeout-title" className={styles.title}>Sitzung läuft ab</h2>
        <p className={styles.inactiveNote}>Keine Aktivität erkannt.</p>
        <p className={styles.message}>
          Aus Sicherheitsgründen werden Sie in{" "}
          <strong>{countdown}</strong>{" "}
          {countdown === 1 ? "Sekunde" : "Sekunden"} abgemeldet.
        </p>
        <div className={styles.progressTrack}>
          <div
            className={styles.progressFill}
            style={{ width: `${Math.min(100, (countdown / warningDurationSecs) * 100)}%` }}
          />
        </div>
        <div className={styles.actions}>
          <button className={styles.btnSecondary} onClick={onLogout}>
            Abmelden
          </button>
          <button className={styles.btnPrimary} onClick={onStay}>
            Angemeldet bleiben
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionTimeoutModal;
